import React from "react";
import { TutorialDiv, TutorialImage, ListTitle } from "..";
import totorialimg from "../../assets/tutorial.svg";
const Tutorial = () => {
  return (
    <>
      <TutorialDiv>
        <TutorialImage src={totorialimg} />
      </TutorialDiv>
    </>
  );
};

export default Tutorial;
